import {CategorySortOrder} from "@mediaspace/shared/types";
import sortWith from "ramda/src/sortWith";
import descend from "ramda/src/descend";
import prop from "ramda/src/prop";
import ascend from "ramda/src/ascend";
import compose from "ramda/src/compose";
import toLower from "ramda/src/toLower";
import {Channel} from "./channel-icon/ChannelIcon";

/**
 * split the channels list to a list of channels with order property
 * and a list of channels without order property in order to manual sort the first and concatenate
 * the second, which will be sorted by name
 * @return object with 2 arrays
 * @param channels
 */
const getSeparatedLists = (channels: Channel[]) => {
    const noOrder: Channel[] = [];
    const withOrder: Channel[] = [];
    channels.forEach((channel) => {
        if ("order" in channel) {
            withOrder.push(channel);
        } else {
            noOrder.push(channel);
        }
    });
    return {
        noOrder,
        withOrder,
    };
};

/**
 * sort channels according to sort operator
 * @return object with 2 arrays
 * @param channels
 * @param sortBy
 */
export const sortChannels = (channels: Channel[], sortBy: string) => {

    switch (sortBy) {
        case CategorySortOrder.RECENT:
            return sortWith<Channel>([
                descend(prop("createdAt")),
            ])(channels);
        case CategorySortOrder.NAME_ASC:
            return sortWith<Channel>([
                ascend(compose(toLower, prop("name"))),
            ])(channels);
        case CategorySortOrder.NAME_DESC:
            return sortWith<Channel>([
                descend(compose(toLower, prop("name"))),
            ])(channels);
        case CategorySortOrder.MEMBERS:
            return sortWith<Channel>([
                descend(prop("membersCount")),
            ])(channels);
        case CategorySortOrder.MEDIA_COUNT:
            return sortWith<Channel>([
                descend(prop("entriesCount")),
            ])(channels);
        case CategorySortOrder.UPDATE_DATE:
            return sortWith<Channel>([
                descend(prop("updatedAt")),
            ])(channels);
        case CategorySortOrder.MANUAL: {
            const lists = getSeparatedLists(channels);
            const sortedByOrder = lists.withOrder.sort((a, b) => {
                return a.order &&
                b.order &&
                Number(a.order) > Number(b.order)
                    ? 1
                    : -1;
            });
            const sortedByName = sortWith<Channel>([
                ascend(prop("name")),
            ])(lists.noOrder);
            return [...sortedByOrder, ...sortedByName];
        }
        default:
            return channels;
    }
}
